import React from "react";
import { PageHero, CTABlock, SectionLabel, CheckList } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";

const points = [
  "Vi kan ta med byggsopor",
  "Vi kan utföra arbetet på helger och kvällar",
  "Ansvarsförsäkring upp till 10 miljoner",
  "All personal har ID06-legitimation",
];

export default function Byggstadning() {
  return (
    <>
      <PageHero
        eyebrow="Företagstjänst"
        title="Byggstädning för nästa steg i projektet"
        intro="Rena Tjänster hjälper till med byggstädning efter renovering, ombyggnation och nyproduktion. Vi kan komma ut på plats, gå igenom behovet och lämna en kostnadsfri offert."
        image={ASSETS.constructionCleaning}
        imageAlt="Byggstädning av Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="bygg-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <section className="py-20 lg:py-28" data-testid="bygg-content">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <SectionLabel className="mb-4">Lång erfarenhet</SectionLabel>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-4">
              Klar för inflytt eller överlämning
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Vår personal har lång erfarenhet av byggstädning och arbetar noggrant för att lokalen
              ska bli redo för nästa steg. Vi anpassar arbetet efter byggprojektets tidsplan.
            </p>
          </div>
          <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 lg:p-10">
            <h3 className="font-display text-xl font-semibold mb-5">Det här lyfter vi</h3>
            <CheckList items={points} />
          </div>
        </div>
      </section>

      <CTABlock
        title="Få en kostnadsfri offert på byggstädning"
        description="Beskriv projektet kort så återkommer vi med en offert. Vi kan vara på plats samma vecka när det är möjligt."
      />
    </>
  );
}
